import {MAX_NUMBER_VALUE} from 'src/constants';

import {isValidEmail} from '@pb/kit-util-is-valid-email';

const VALIDATION_REGEX = /[^-0-9 A-Za-z_.@+']/g;
const RTS_ID_VALIDATION_REGEX = /[^-0-9 A-Za-z]/g;


export const validatePbRtsId = (pbRtsId: string) => {
    const validValue = pbRtsId.replace(RTS_ID_VALIDATION_REGEX, '');
    return validValue === pbRtsId;
};

export const validateName = (name: string) => {
    const validValue = name.replace(VALIDATION_REGEX, '');
    return name === validValue;
};
export const validateEmails = (email: string, itemsLength: number) => {
    if (itemsLength === 1) {
        return email.length <= 200;
    } else {
        return email.length <= 200 && isValidEmail(email);
    }
};

export const validateUserIds = (id: string) => !isNaN(+id) && +id > 0 && +id < MAX_NUMBER_VALUE;
